import React from 'react';
import { RedirectTableCell } from '../../components/utilities/Table/RedirectTableCell';
import { RequestIdTableCell } from '../../components/utilities/Table/RequestIdTableCell';

const requestsListStatus = [
    {
        id: 'desembolsadas',
        label: 'DESEMBOLSADAS',
        status: '90',
        responsable: null,
        columns: [
            {
                Header: () => 'Solicitud',
                id: 'id',
                typeId: 'HeaderRequest',
                Cell: ({ row }) => {
                    return <RequestIdTableCell row={row} />;
                },
            },
            {
                Header: 'Fecha Desembolso',
                accessor: 'gestionsolicitud.fecha_desembolso',
            },
            {
                Header: 'Producto',
                accessor: 'subproducto.label',
            },
            {
                Header: 'Oficina',
                accessor: 'oficina.label',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                typeId: 'HeaderIdentification',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                typeId: 'HeaderClient',
            },
        ],
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
